/* src/components/edit-remark-modal/edit-remark-modal.component.scss */
textarea {
  width: 500px;
  height: 150px;
}
textarea:disabled {
  background: var(--vwui-color-neutral-3);
}
/*# sourceMappingURL=edit-remark-modal.component-RXMHVAJL.css.map */
